import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Idioma } from '../../models/idioma';

@Pipe({
    name: 'idiomas' // nombre del pipe en las directivas
})

export class IdiomasPipe implements PipeTransform{
    // Métdodo a implementar siempre
    transform(idiomas:Observable<any>){
        // Se inicializa un arreglo vacío
        let arregloIdiomas:Array<Idioma> = [];

        for(let item in idiomas){
            let idioma:Idioma = new Idioma(item, idiomas[item]);
            arregloIdiomas.push(idioma);
        }

        return arregloIdiomas;
    }
}


// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/idiomas.pipe.ts